export default __webpack_public_path__ + "static/media/kore.dc73b12e.svg";